import { render, staticRenderFns } from "./PopupMessage.vue?vue&type=template&id=5cc7ca96&"
import script from "./PopupMessage.vue?vue&type=script&lang=ts&"
export * from "./PopupMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports